/* eslint-disable tss-unused-classes/unused-classes */
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const furnitureModStyles = makeStyles<{ isExpanded?: boolean }>()((theme: Theme, { isExpanded }) => ({
  expandedGrid: {
    fontSize: '14px',
    '& .MuiDataGrid-main': {
      minHeight: '60px',
    },
  },
  switchLightBlue: {
    '& .MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#A8CAED',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#A8CAED',
    },
  },
  switchPrimary: {
    '& .MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.secondary.main,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  billablelb: {
    fontSize: '12px !important',
    fontWeight: 'bold',
    marginRight: '24px',
  },
  billableValue: {
    marginRight: '70px',
  },
  quantityValue: {
    '& .MuiDataGrid-cell': {
      paddingLeft: '24px',
    },
  },
  gridRow: {
    marginTop: '20px',
    marginBottom: '24px',
  },
  isErrorCell: {
    border: '1px solid !important',
    borderColor: 'red',
    color: 'red',
  },
}));
